(function () {
  'use strict';

  /* Guard anti-doppia inizializzazione */
  if (window.__pmPredictiveSearchAssetLoaded) return;
  window.__pmPredictiveSearchAssetLoaded = true;

  var psResults = document.getElementById('pm-search-results');
  var psQuicks  = document.querySelector('.pm-search-panel__quicklinks');
  var psInput   = document.getElementById('pm-search-input');
  var psAbort   = null;
  var psTimer   = null;

  function psHide() {
    clearTimeout(psTimer);
    if (psAbort) { psAbort.abort(); psAbort = null; }
    if (psResults) psResults.hidden = true;
    if (psQuicks)  psQuicks.hidden  = false;
  }

  function psEsc(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* i18n (2026-09-11): strings from window.pmI18n (printed by snippets/pm-localization.liquid), Italian fallback */
  var I = window.pmI18n || {};
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function psT(k, fb) { return (I[k] != null && I[k] !== '') ? I[k] : fb; }

  function psFmt(priceStr) {
    var n = parseFloat(priceStr);
    return isNaN(n) ? '' : '\u20AC ' + n.toFixed(2).replace('.', ',');
  }

  function psRender(products, queries, collections, q) {
    var safe   = psEsc(q);
    var encQ   = encodeURIComponent(q);
    var seeAll = '<a href="' + ROOT + 'search?q=' + encQ + '" class="pm-search-results__see-all">' + psT('psSeeAll', 'Cerca "[q]"').replace('[q]', safe) + ' \u2192</a>';

    /* Unisce query text suggestions + collection matches (come la pagina /search) */
    var rawSuggestions = queries.concat(collections.map(function (c) {
      return { text: c.title, url: c.url };
    }));

    if (!products.length && !rawSuggestions.length) {
      return '<p class="pm-search-results__empty">' + psT('psNoResults', 'Nessun risultato trovato') + '</p>' + seeAll;
    }

    /* Colonna suggerimenti */
    var sugCol = '';
    if (rawSuggestions.length) {
      var sugItems = rawSuggestions.map(function (s) {
        /* query items: possono avere styled_text con <mark>; collection items: solo title */
        var label = (s.styled_text && s.styled_text.indexOf('<mark>') !== -1)
          ? s.styled_text
          : psEsc(s.text || s.title || '');
        var href  = s.url || (ROOT + 'search?q=' + encodeURIComponent(s.text || s.title || ''));
        return '<li><a href="' + href + '" class="pm-search-results__sug-link">' + label + '</a></li>';
      }).join('');
      sugCol = '<div class="pm-search-results__col pm-search-results__col--sug">'
        + '<p class="pm-search-results__heading">' + psT('psSuggestions', 'Suggerimenti') + '</p>'
        + '<ul class="pm-search-results__sug-list" role="list">' + sugItems + '</ul>'
        + '</div>';
    }

    /* Colonna prodotti */
    var prodContent = products.length
      ? '<ul class="pm-search-results__list" role="list">'
        + products.map(function (p) {
            var imgUrl = p.featured_image ? p.featured_image.url.split('?')[0] + '?width=104' : null;
            var img    = imgUrl
              ? '<img src="' + imgUrl + '" alt="" class="pm-search-results__img" loading="lazy" width="52" height="52">'
              : '<div class="pm-search-results__img-placeholder"></div>';
            var price  = p.price ? '<span class="pm-search-results__price">' + psFmt(p.price) + '</span>' : '';
            return '<li class="pm-search-results__item">'
              + '<a href="' + p.url + '" class="pm-search-results__link">'
              + img
              + '<span class="pm-search-results__info">'
              + '<span class="pm-search-results__title">' + psEsc(p.title) + '</span>'
              + price + '</span></a></li>';
          }).join('')
        + '</ul>'
      : '<p class="pm-search-results__empty-col">' + psT('psNoProducts', 'Nessun prodotto trovato') + '</p>';

    var prodCol = '<div class="pm-search-results__col pm-search-results__col--prod">'
      + '<p class="pm-search-results__heading">' + psT('psProducts', 'Prodotti') + '</p>'
      + prodContent + '</div>';

    return '<div class="pm-search-results__grid">' + sugCol + prodCol + '</div>' + seeAll;
  }

  function psFetch(q) {
    if (psAbort) psAbort.abort();
    psAbort = new AbortController();
    if (psResults) {
      psResults.innerHTML = '<div class="pm-search-results__loading" aria-hidden="true"><span></span><span></span><span></span></div>';
      psResults.hidden = false;
    }
    if (psQuicks) psQuicks.hidden = true;
    fetch(
      ROOT + 'search/suggest.json?q=' + encodeURIComponent(q)
        + '&resources[type]=product,query,collection&resources[limit]=5&resources[limit_scope]=each',
      { signal: psAbort.signal }
    )
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) {
        var products    = (d.resources && d.resources.results && d.resources.results.products)    || [];
        var queries     = (d.resources && d.resources.results && d.resources.results.queries)     || [];
        var collections = (d.resources && d.resources.results && d.resources.results.collections) || [];
        if (psResults) { psResults.innerHTML = psRender(products, queries, collections, q); psResults.hidden = false; }
      })
      .catch(function (e) { if (e.name !== 'AbortError') psHide(); });
  }

  if (psInput) {
    psInput.addEventListener('input', function () {
      var q = psInput.value.trim();
      clearTimeout(psTimer);
      if (q.length < 2) { psHide(); return; }
      psTimer = setTimeout(function () { psFetch(q); }, 280);
    });
  }

  document.addEventListener('pm:search-close', function () { psHide(); });

})();
